/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
/* eslint-disable react/button-has-type */
import styled from "styled-components";

const InnerContainer = styled.div`
  top: 10%;
  left: 2%;
  z-index: 99;
  width: 70%;
`;
const TimerContainer = styled.div``;
const TimeUnit = styled.span`
  font-weight: 500;
  font-size: 19px;
  line-height: 22px;
  line-height: 49px;
  color: ${(props) => props.theme.colors.black};
`;
const Button = styled.button``;
// TODO: Fix this, this is temporary fix
// Notice that each time that the timer updated the background image of
// the parent updates as well - that needs fixing
// if you use a state in your component its better if the component will be OOP
export default function TimerOld({
  startTime = 0,
  reverse = false,
  formattedTime = true,
  clearTimer,
  toggleClearTimer,
  timeSeconds,
  setTimeSeconds,
  hasBeenMadeRestartGame,
  setHasBeenMadeRestartGame,
  toggleResetTimer,
  resetTimer,
  isGamePaused,
  localTimerOfPreviousGame,
  setLocalTimerOfPreviousGame,
}) {
  // const [active, setActive] = useState(true);

  const [seconds, setSeconds] = useState(startTime);
  const [isActive, setIsActive] = useState(clearTimer);
  const [flag, setFlag] = useState(true);
  useEffect(() => {
    console.log("aa", isGamePaused);
    if (reverse && seconds <= 0) {
      return null;
    }
    if (seconds == 0 && flag) {
      setSeconds(timeSeconds + 1);
    } else {
      setFlag(true);
    }
    if (resetTimer) {
      setSeconds(0);
      toggleResetTimer(false);
      setFlag(false);
    }
    if (localTimerOfPreviousGame != 0) {
      setSeconds(localTimerOfPreviousGame);
      setLocalTimerOfPreviousGame(0);
    }
    let interval = null;
    if (isActive && !isGamePaused) {
      interval = setInterval(() => {
        setSeconds((prevState) => (reverse ? prevState - 1 : prevState + 1));
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    setTimeSeconds(seconds);
    return () => clearInterval(interval);
  }, [
    hasBeenMadeRestartGame,
    isActive,
    isGamePaused,
    resetTimer,
    reverse,
    seconds,
    setHasBeenMadeRestartGame,
    setTimeSeconds,
    toggleClearTimer,
    toggleResetTimer,
    localTimerOfPreviousGame,
    setLocalTimerOfPreviousGame,
    timeSeconds,
    flag,
  ]);

  const active = !isActive && setIsActive(true);

  return (
    <InnerContainer>
      {formattedTime ? (
        <TimerContainer>
          <TimeUnit>
            {`0${Math.floor((seconds / 3600) % 60)}`.slice(-2)}:
            {`0${Math.floor((seconds / 60) % 60)}`.slice(-2)}:
            {`0${Math.floor(seconds % 60)}`.slice(-2)}
          </TimeUnit>
        </TimerContainer>
      ) : (
        seconds
      )}
    </InnerContainer>
  );
}
